import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import React from "react";
import Checkmark from "../CheckMark/Checkmark";
import CancelIcon from "@mui/icons-material/Cancel";

const Loading = ({ open, closeLoading, title }) => {
  const [progress, setProgress] = React.useState(0);

  /* React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(timer);
          return 100;
        }
        return prevProgress + 20;
      });
    }, 800);

    return () => {
      clearInterval(timer); // Clean up the interval on component unmount
    };
  }, []); */

  return (
    <Backdrop
      sx={{
        backgroundColor: "rgba(0,0,0,0.8)",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={open}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        gap={2}
        justifyContent={"center"}
        alignItems={"center"}
      >
        {/*     <CircularProgress
            sx={{ color: "#fff" }}
            variant="determinate"
            value={progress}
            size={"6rem"}
          /> */}
        {progress !== 100 ? (
          <CircularProgress sx={{ color: "#fff" }} size={"6rem"} />
        ) : (
          <Checkmark />
        )}
        {progress !== 100 ? (
          <Typography variant="h5" color={"#fff"} fontWeight={400}>
            {title ? title : "Deploying"}
          </Typography>
        ) : (
          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={2}
            alignItems={"center"}
          >
            <Typography variant="h5" color={"#fff"} fontWeight={400}>
              Deployed
            </Typography>
            <CancelIcon
              onClick={closeLoading}
              sx={{ cursor: "pointer", fontSize: "2rem", color: "#fff" }}
            />
          </Box>
        )}
      </Box>
    </Backdrop>
  );
};

export default Loading;
